<template>
  <figure class="short">
    <div class="clip-media" @click="playing = true">
      <video v-if="playing" :src="short.url" controls autoplay playsinline :poster="short.posterUrl"></video>
      <template v-else>
        <img v-if="short.posterUrl" :src="short.posterUrl" :alt="short.title || 'Short'" loading="lazy" />
        <span class="play-badge"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5v14l11-7z" /></svg></span>
      </template>
    </div>
    <figcaption class="short-body">
      <p class="short-t">{{ short.title || 'Short' }}</p>
      <span class="short-m">{{ meta }}</span>
    </figcaption>
  </figure>
</template>

<script>
export default {
  name: 'ShortCard',
  props: { short: { type: Object, required: true } },
  data() {
    return { playing: false };
  },
  computed: {
    meta() {
      return (this.short.timestamp || '') + (this.short.length ? ` · ${this.short.length}s` : '');
    },
  },
};
</script>
